import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { PdsSkeletonLoader as PdsSkeletonLoaderElement } from '@principal/design-system';

export const PdsSkeletonLoader = createComponent({
  tagName: 'pds-skeleton-loader',
  elementClass: PdsSkeletonLoaderElement,
  react: React,
});
